import React from "react"

import { contentMap } from "./contentMap"

import styles from "./CreditRequestInstructions.module.less"

export const CreditRequestInstructions = ({ reason, paymentProcessor = "stripe" }) => {
  const Instruction =
    contentMap[paymentProcessor]?.[reason] ||
    contentMap[paymentProcessor]?.Other ||
    contentMap.other?.[reason] ||
    contentMap.other?.Other

  return (
    <div className={styles.instructionsWrapper}>
      <div className={styles.instructions}>{Instruction && <Instruction />}</div>
    </div>
  )
}
